<!--
  支付设置
  lovi 2020-1-14
-->
<template>
  <div class="w100">
    <van-nav-bar
      :title="$t('securitySet.paySet')"
      :fixed="true"
      left-arrow
      @click-left="_back"
    />
    <div class="scroll-wrapper">
      <scroll>
        <van-cell-group>
          <van-cell
            :title="$t('securitySet.defaultPaymentSetting')"
            is-link
            :value="
              payTypeName
                ? payTypeName
                : $t('securitySet.defaultPaymentSetting')
            "
            @click="payTypeFlag = true"
          />
          <van-cell
            v-if="userInfo.is_set_password == false"
            :title="$t('payPsd.SetPayPsd')"
            is-link
            @click="changePayPsd('set')"
          />
          <van-cell
            v-else
            :title="$t('payPsd.modifyPayPsd')"
            is-link
            @click="changePayPsd('edit')"
          />
        </van-cell-group>
      </scroll>
    </div>

    <!-- 选择扣款顺序 -->
    <van-popup v-model="payTypeFlag" position="bottom" get-container="body">
      <van-picker
        show-toolbar
        :title="$t('securitySet.defaultPaymentSetting')"
        :default-index="payTypeIndex"
        :columns="payTypeList"
        @cancel="payTypeFlag = false"
        @confirm="payTypeConfirm"
      />
    </van-popup>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "paySet",
  meta: {
    service: false // 客服
  },
  components: {},
  data() {
    return {
      // 扣款顺序选择
      payTypeFlag: false,
      payTypeIndex: 0,
      payTypeName: "",
      payTypeList: []
    };
  },
  created() {},
  mounted() {},
  computed: {
    ...mapGetters(["userInfo"])
  },
  methods: {
    payTypeConfirm(picker, value) {
      // 选择扣款顺序
      let vm = this;
      vm.payTypeFlag = false;
      vm.payTypeIndex = value;
      vm.payTypeName = picker.text;
      vm.payTypeDefault(picker.type);
      console.log("payTypeConfirm", picker);
    },
    payTypeDefault(type) {
      // 修改默认支付方式
      let vm = this;
      vm.$post(
        "/app/user/payTypeDefault",
        { type: type },
        { loading: true }
      ).then(res => {
        console.log("payTypeDefault", res);
        vm.$store.dispatch("GET_USER_INFO");
      });
    },
    _getPayType() {
      let vm = this;
      vm.payTypeList = [];
      vm.$post("/app/user/payType", {}, { loading: true }).then(res => {
        console.log("payType", res);
        for (var i = 0; i < res.length; i++) {
          let newData = res[i];
          newData.text = res[i].name;
          vm.payTypeList.push(newData);
          if (vm.userInfo.pay_type == res[i].type) {
            vm.payTypeIndex = i;
            vm.payTypeName = res[i].name;
          }
        }
        console.log("vm.payTypeList", vm.payTypeList);
      });
    },
    changePayPsd(flag) {
      if (flag == "set") {
        // 设置支付密码
        this.$router.push({
          path: "/payPsd",
          query: { flag: "set" }
        });
      }
      if (flag == "edit") {
        // 修改支付密码
        this.$router.push({
          path: "/payPsd",
          query: { flag: "edit" }
        });
      }
    }
  },
  watch: {
    userInfo: {
      handler(obj) {
        if (obj.username) {
          this._getPayType();
        }
      },
      immediate: true
    }
  }
};
</script>

<style lang="less" scoped></style>
